module.exports = __webpack_public_path__ + "static/media/YF03_2.748ae211.jpg";